import { render, staticRenderFns } from "./RadialProgressBar.vue?vue&type=template&id=4201ec9c"
import script from "./RadialProgressBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./RadialProgressBar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports